import { RedocStandalone } from 'redoc'
import { theme } from './Theme'

function getSpecUrl(basePath) {
  const requestedVersion = new URLSearchParams(window.location.search).get('version')

  if (requestedVersion && /^[a-z0-9.-]+$/i.test(requestedVersion)) {
    return `${basePath}/jsons/versions/${requestedVersion}/api.json`
  }

  return `${basePath}/jsons/api.json`
}

function App() {
  const basePath = process.env.REACT_APP_SPEC_BASE_URL || window.location.origin

  return (
    < RedocStandalone
      specUrl={getSpecUrl(basePath)}
      options={{theme}}
    />
  )
}

export default App
